import { YodaFontSize, YodaFontWeight, YodaColors, YodaBorderRadius } from 'yoda-ui/yodaTheme';

export const dateRangePickerStyles = ({
  textField: {
    width: '100%',

    '& .MuiOutlinedInput-root': {
      borderRadius: YodaBorderRadius.small,
      paddingRight: '4px',

      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: YodaColors.textSecondary,
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: YodaColors.textSecondary,
      },
    },

    '& label': {
      fontSize: YodaFontSize.medium,
      fontWeight: YodaFontWeight.light,
    },

    '& input': {
      fontSize: YodaFontSize.medium,
      fontWeight: YodaFontWeight.light,
      height: '15px',

      '&::placeholder': {
        color: YodaColors.gray3,
        opacity: 0.8,
        fontSize: YodaFontSize.medium,
      },
    },
  },
  box: {
    mx: '8px',
  },

});
